"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFormulaMember = exports.thresholdChange = exports.shouldShowDelete = exports.isTextOnlyRule = exports.isOutsideFunction = exports.isBetweenFunction = exports.isBaseArgumentInFunction = exports.hasReachedMaxNestingDept = exports.getFormulaActions = exports.formulaType = exports.formulaChange = exports.deleteFormulaMember = exports.defaultPensionModel = exports.createInitialFormula = exports.areParanthesesEnabled = exports.areFunctionsEnabled = exports.addParanthesis = exports.addFunctionBetween = exports.addFunction = exports.addFormulaMember = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _constants = require("./constants");
var _FormulaMember = _interopRequireDefault(require("./FormulaMember"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var functionMaxNestingDepth = 5;
var isPsOrContributionBase = function isPsOrContributionBase(focusedPath, builderData) {
  var last = R.takeLast(3, focusedPath);
  if (R.prop('value', R.path(focusedPath, builderData)) === 'pensionable salary') {
    return true;
  }
  if (R.prop(0, last) === 'contribution' && R.prop(2, last) === 0) {
    return true;
  }
  return false;
};
var isBaseArgumentInFunction = exports.isBaseArgumentInFunction = function isBaseArgumentInFunction(focusedPath) {
  var lastElems = R.takeLast(3, focusedPath);
  if (R.prop(0, lastElems) === 'arguments' && (R.prop(1, lastElems) === 0 || R.prop(1, lastElems) === 1) && R.prop(2, lastElems) === 0 || lastElems[0] === 'contribution' && lastElems[2] === 0) {
    return true;
  }
  return false;
};
var isOutsideFunction = exports.isOutsideFunction = function isOutsideFunction(newKeysPath) {
  return newKeysPath.slice(0, newKeysPath.length - 2).pop() === 'arguments' ? newKeysPath.slice().pop() !== 0 : true;
};
var isBetweenFunction = exports.isBetweenFunction = function isBetweenFunction(data, index, pensionFocusedElement) {
  var elem = R.path([pensionFocusedElement[0], 'thresholdRows', index], data);
  if (R.prop('isBetween', elem) || R.prop('min', elem) && R.prop('max', elem)) {
    return true;
  }
  return false;
};
var withFormulaMember = exports.withFormulaMember = function withFormulaMember(requiredProps, props) {
  return /*#__PURE__*/_react["default"].createElement(_FormulaMember["default"], _extends({}, requiredProps, props));
};
var hasReachedMaxNestingDept = exports.hasReachedMaxNestingDept = function hasReachedMaxNestingDept(path) {
  return R.filter(R.equals('arguments'), path).length >= functionMaxNestingDepth;
};
var areFunctionsEnabled = exports.areFunctionsEnabled = function areFunctionsEnabled(_ref) {
  var disabled = _ref.disabled,
    focusedElementType = _ref.focusedElementType,
    builderData = _ref.builderData,
    focusedPath = _ref.focusedPath;
  return !disabled && (focusedElementType === _constants.FORMULA_MEMBER_TYPES.operator || R.isEmpty(builderData) || isBaseArgumentInFunction(focusedPath) || focusedElementType === _constants.FORMULA_MEMBER_TYPES.functionMember || hasReachedMaxNestingDept(focusedPath));
};
var areParanthesesEnabled = exports.areParanthesesEnabled = function areParanthesesEnabled(_ref2) {
  var disabled = _ref2.disabled,
    focusedElementType = _ref2.focusedElementType,
    builderData = _ref2.builderData,
    focusedPath = _ref2.focusedPath;
  return !disabled && !isPsOrContributionBase(focusedPath, builderData) && !isBaseArgumentInFunction(focusedPath) && (focusedElementType === _constants.FORMULA_MEMBER_TYPES.variable || focusedElementType === _constants.FORMULA_MEMBER_TYPES.numeric || focusedElementType === _constants.FORMULA_MEMBER_TYPES.percentage || focusedElementType === _constants.FORMULA_MEMBER_TYPES.functionMember);
};
var defaultPensionModel = exports.defaultPensionModel = {
  contribution: {
    formulaItems: [{
      arguments: null,
      type: _constants.FORMULA_MEMBER_TYPES.variable,
      value: '',
      key: (0, _uuid.v4)()
    }]
  },
  thresholdRows: [{
    field: 'pensionable salary',
    max: null,
    min: null
  }]
};
var createInitialFormula = exports.createInitialFormula = function createInitialFormula(data) {
  return [_objectSpread({
    key: (0, _uuid.v4)()
  }, data)];
};
var deleteFormulaMember = exports.deleteFormulaMember = function deleteFormulaMember(formula) {
  return function (path) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    if (!R.path(path, data)) return false;
    if (isBaseArgumentInFunction(path)) {
      R.path(parentKeysPath, data).splice(childKey, 1, {
        key: (0, _uuid.v4)(),
        value: '',
        type: _constants.FORMULA_MEMBER_TYPES.variable,
        displayName: ''
      });
    } else {
      R.path(parentKeysPath, data).splice(childKey, 1);
    }
    return data;
  };
};
var addFormulaMember = exports.addFormulaMember = function addFormulaMember(formula) {
  return function (currentElementType, path, value) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    R.path(parentKeysPath, data).splice(childKey + 1, 0, {
      key: (0, _uuid.v4)(),
      value: '',
      type: currentElementType === _constants.FORMULA_MEMBER_TYPES.operator || currentElementType === _constants.FORMULA_MEMBER_TYPES.parenthesis && value === '(' ? _constants.FORMULA_MEMBER_TYPES.variable : _constants.FORMULA_MEMBER_TYPES.operator,
      displayName: ''
    });
    return data;
  };
};
var addParanthesis = exports.addParanthesis = function addParanthesis(formula, type) {
  return function (path) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    R.path(parentKeysPath, data).splice(type === 'left' ? childKey : childKey + 1, 0, {
      key: (0, _uuid.v4)(),
      value: type === 'left' ? '(' : ')',
      type: _constants.FORMULA_MEMBER_TYPES.parenthesis,
      displayName: ''
    });
    return data;
  };
};
var addFunctionTypeAndTypeField = function addFunctionTypeAndTypeField(type) {
  if (_constants.roundFunctionTypes.includes(type)) {
    return {
      type: _constants.FORMULA_MEMBER_TYPES.numeric,
      dataType: _constants.DATA_TYPES.NUMERIC
    };
  }
  return {
    type: _constants.FORMULA_MEMBER_TYPES.variable,
    dataType: _constants.DATA_TYPES.MIXED
  };
};
var addFunction = exports.addFunction = function addFunction(formula, type) {
  return function (path) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    var focusedElement = R.path(path, data);
    var focusedType = R.prop('type', focusedElement);
    if (focusedType === _constants.FORMULA_MEMBER_TYPES.functionMember) {
      focusedElement.value = type;

      //when add/change function reset second argument
      var lastFocusedArgument = focusedElement.arguments[focusedElement.arguments.length - 1][0];
      focusedElement.arguments = R.update(1, [_objectSpread(_objectSpread(_objectSpread({}, lastFocusedArgument), _constants.DEFAULT_FUNCTION_ARGUMENT), addFunctionTypeAndTypeField(type))], focusedElement.arguments);
      return data;
    }
    if (isBaseArgumentInFunction(path)) {
      childKey = R.takeLast(2);
      R.path(parentKeysPath, data).splice(childKey, 1);
    }
    R.path(parentKeysPath, data).splice(childKey + 1, 0, {
      key: (0, _uuid.v4)(),
      value: type,
      type: _constants.FORMULA_MEMBER_TYPES.functionMember,
      arguments: [[_objectSpread({
        key: (0, _uuid.v4)()
      }, _constants.DEFAULT_FUNCTION_ARGUMENT)], [_objectSpread(_objectSpread({
        key: (0, _uuid.v4)()
      }, _constants.DEFAULT_FUNCTION_ARGUMENT), addFunctionTypeAndTypeField(type))]]
    });
    return data;
  };
};
var formulaChange = exports.formulaChange = function formulaChange(formula) {
  return function (data, path) {
    var elements = R.clone(formula);
    var updatedElement = R.path(path, elements);
    updatedElement.value = data.value;
    updatedElement.description = data.description;
    updatedElement.dataSource = data.dataSource;
    updatedElement.displayName = data.label || data.displayName || '';
    updatedElement.type = data.type;
    return elements;
  };
};
var thresholdChange = exports.thresholdChange = function thresholdChange(threshold) {
  return function (type, _ref3) {
    var thresholdIndex = _ref3.thresholdIndex,
      sourceThreshold = _ref3.sourceThreshold,
      thresholdData = _ref3.thresholdData;
    var ruleThresholds = R.clone(threshold);
    switch (type) {
      case 'update':
        {
          ruleThresholds[thresholdIndex] = thresholdData;
          break;
        }
      case 'add':
        {
          ruleThresholds = R.insert(thresholdIndex + 1, _objectSpread({
            name: "threshold-".concat(ruleThresholds.length),
            key: (0, _uuid.v4)()
          }, defaultPensionModel), ruleThresholds);
          break;
        }
      case 'duplicate':
        {
          ruleThresholds = R.insert(thresholdIndex + 1, _objectSpread(_objectSpread({}, sourceThreshold), {}, {
            key: (0, _uuid.v4)(),
            name: "threshold-".concat(ruleThresholds.length)
          }), ruleThresholds);
          break;
        }
      case 'delete':
        {
          ruleThresholds.splice(thresholdIndex, 1);
          break;
        }
      default:
    }
    return ruleThresholds;
  };
};
var addFunctionBetween = exports.addFunctionBetween = function addFunctionBetween(threshold) {
  return function (thresholdIndex, blockIndex) {
    var ruleThresholds = R.clone(threshold);
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].isBetween = true;
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].min = null;
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].max = null;
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].isInclusive = true;
    return ruleThresholds;
  };
};
var enhancedRuleChange = function enhancedRuleChange(field, formula, ruleChange, other) {
  if (field === 'complex') {
    var complex = other.rule.complex;
    var activeType = complex.activeType;
    var complexObject = _objectSpread(_objectSpread({}, complex), {}, _defineProperty({}, activeType, _objectSpread(_objectSpread({}, complex[activeType]), {}, _defineProperty({}, other.key, formula))));
    return ruleChange(field, complexObject, false, true);
  }
  return ruleChange(field, formula, false, true);
};
var getFormulaActions = exports.getFormulaActions = function getFormulaActions(field, source, ruleChange) {
  var other = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    addFormulaMember: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFormulaMember(source)),
    deleteFormulaMember: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, deleteFormulaMember(source)),
    addFunctionMin: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.MIN)),
    addFunctionMax: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.MAX)),
    addFunctionRound: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.ROUND)),
    addFunctionRoundUp: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.ROUND_UP)),
    addFunctionRoundDown: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.ROUND_DOWN)),
    addLeftBracket: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addParanthesis(source, _constants.FUNCTION_MEMBER_TYPES.LEFT)),
    addRightBracket: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addParanthesis(source, _constants.FUNCTION_MEMBER_TYPES.RIGHT)),
    formulaChange: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, formulaChange(source)),
    thresholdChange: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, thresholdChange(source)),
    addFunctionBetween: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunctionBetween(source))
  };
};
var isTextOnlyRule = exports.isTextOnlyRule = R.compose(R.propEq('type', _constants.FORMULA_MEMBER_TYPES.textOnly), R.head);
var formulaType = exports.formulaType = R.compose(R.prop('type'), R.head);
var shouldShowDelete = exports.shouldShowDelete = function shouldShowDelete(_ref4) {
  var noDelete = _ref4.noDelete,
    isFocused = _ref4.isFocused,
    keysPath = _ref4.keysPath,
    isBaseInFunction = _ref4.isBaseInFunction,
    type = _ref4.type;
  return !noDelete && isFocused && (isOutsideFunction(keysPath) || isBaseInFunction && type === _constants.FORMULA_MEMBER_TYPES.functionMember);
};